<template>

    <el-select :size="size"
            :value="value"
            :multiple="multiple"
            :collapse-tags="multiple"
            :filterable="filterable"
            :disabled="disabled"
               :clearable="clearable"
            @change="change($event)">
        <el-option v-for="item in deptList" :label="item.name" :value="item.id"
                   :key="item.id"></el-option>
    </el-select>

</template>


<script>

    import selectUtil from '@/util/common/select'
    import { createNamespacedHelpers } from 'vuex';

    const deptNSHelper = createNamespacedHelpers( "dept" );

    export default {

        name: 'deptSelect',

        props: ['value', 'multiple', 'allowAll', 'filterable', 'clearable', 'disabled', 'size'],

        data() {
            return {
                oldKeys: [],
                deptList: [],
                deptListSource$: null,
            }
        },

        mounted() {
            //mapAction定义返回一个Observable，通过computed监听得到deptSource
            this.getDeptSource();

            let that = this;
            this.deptSource$.subscribe(v => {
                that.deptList = v;
                if (that.multiple && that.allowAll) {
                    that.deptList = selectUtil.allowAll(that.deptList, 'id', 'name');
                }
                this.$emit('fetchAllDepts', that.deptList);
            });
        },

        methods: {
            ...deptNSHelper.mapActions(['getDeptSource']),

            change: function (newDeptKeys) {
                if (this.multiple) {
                    this.$emit('input', selectUtil.getSelectedItems(this.oldKeys, this.deptList, newDeptKeys, 'id'));
                } else {
                    this.$emit('input', newDeptKeys);
                }
            },

        },

        computed: {
            ...deptNSHelper.mapGetters(['deptSource$']),
        },


    }

</script>